import React, { Fragment, useEffect, useState } from "react";
import {
	Link,
	useLocation,
	useNavigate,
	useParams,
	useSearchParams,
} from "react-router-dom";
import Slider from "react-slick";
import { Modal } from "react-bootstrap";
import Quickview from "../../layouts/Quickview";
import Masonry from "react-masonry-component";
import { addBasket } from "../../../redux/reducers/basket";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import SelectMode from "../../layouts/SelectMode";
import QuickviewOptions from "../../layouts/QuickviewOptions";
import { getProductTotalPrice } from "../../../utils/commons";



const Content = (props) => {
	const basket = useSelector((state) => state.basket);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [searchParams] = useSearchParams();
	const location = useLocation();
	const [state, setState] = useState({
		modalshow: false,
		lastActiveBox: -1,
		filteredProducts: props.allItems,
		activeItem:
			searchParams.get("category") || props.categories[0].categoryName,
		showSelectMode: true,
	});
	const sliderRef = useRef(null);
	// Modal
	const modalShow = (index) => {
		document.documentElement.style.overflowY = "hidden";
		setState({ ...state, modalshow: true, lastActiveBox: index });
	};
	// Modal
	const modalOptionsShow = (index) => {
		document.documentElement.style.overflowY = "hidden";
		setState({ ...state, modaloptions: true, lastActiveBox: index });
	};

	const modalClose = () => {
		document.documentElement.style.overflowY = "scroll";
		setState({ ...state, modaloptions: false, modalshow: false });
	};

	useEffect(() => {
		// setState({ ...state, activeItem: props.categories[0].categoryName });
		handleClick(state.activeItem);
	}, []);

	const handleClick = (id) => {
		let filteredProducts = [];
		if (id === -1) {
			filteredProducts = props.allItems;
		} else {
			let params = new URLSearchParams({ category: id });

			navigate(location.pathname + "?" + params.toString(), {
				replace: true,
			});

			filteredProducts = props.allItemsByCategory[id];
		}
		setState({ ...state, filteredProducts, activeItem: id });
	};
	const settings = {
		slidesToShow: props.categories.length >= 8 ? 8 : props.categories.length,
		slidesToScroll: 3,
		arrows: props.categories.length >= 8,
		dots: false,

		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow:
						props.categories.length > 6 ? 6 : props.categories.length,
					arrows: props.categories.length > 6,
				},
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow:
						props.categories.length > 4 ? 4 : props.categories.length,
					arrows: props.categories.length > 3,
				},
			},
			{
				breakpoint: 575,
				settings: {
					slidesToShow:
						props.categories.length > 3 ? 3 : props.categories.length,
					arrows: true,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow:
						props.categories.length > 2 ? 2 : props.categories.length,
					arrows: true,
					slidesToScroll: 1,
				},
			},
		],
	};
	const imagesLoadedOptions = {
		itemSelector: ".masonry-item",
		percentPosition: true,
		resize: true,
		fitWidth: true,
	};
	const onClickItem = (item, event) => {
		event && event.stopPropagation();
		if (item.disabled) {
			return;
		} else if (item.productId) {
			if (item.optionLists && item.optionLists.length) {
				modalOptionsShow(item.productId);
			} else {
				addProductToCart(item, event);
			}
		} else {
			// modalShow(item.menuId);
			window.location = "/menu/" + item.menuId;
		}
	};

	const addProductToCart = (itemToAdd, event, fromOptionModal = false) => {
		try {
			let item = { ...itemToAdd };

			item.productPrice = itemToAdd.price;

			if (!item.quantity) {
				item.quantity = 1;
			}

			item.price =
				basket.mode == "takeAway" && item.priceTakeAway > 0
					? item.priceTakeAway
					: basket.mode == "delivery" && item.priceDelivery > 0
					? item.priceDelivery
					: item.price;

			item.price = getProductTotalPrice(item.price, item, itemToAdd.content);

			item.type = "product";
			item.basePrice = item.price;

			dispatch(
				addBasket({
					...item,
					quantity: 1,
				})
			);
			if (event) {
				const target = event.currentTarget;
				target.classList.add("added-to-cart");
				setTimeout(() => target.classList.remove("added-to-cart"), 1000);
			}
			if (fromOptionModal) {
				modalClose();
			}
		} catch (e) {
			console.error(e);
		}
	};

	const showArrows = () => {
		const windowWidth = window.innerWidth;

		return (
			sliderRef.current &&
			((windowWidth > 1200 && sliderRef.current.props.arrows) ||
				(windowWidth <= 1200 &&
					sliderRef.current.props.responsive.find((r) => {
						if (r.breakpoint >= windowWidth) {
							return r.settings.arrows;
						} else {
							return false;
						}
					})))
		);
	};
	const renderAll = state.filteredProducts
		.filter(
			(item) =>
				!item.servicesAvailability ||
				item.servicesAvailability.includes(basket.mode)
		)
		.map((item, i) => (
			<div key={i} className="col-lg-4 col-md-6 masonry-item sides">
				{item.disabled == 1 && (
					<div className="disabled-container">
						<span className="disabled-text">Indisponible</span>
					</div>
				)}
				<div className={"product " + (item.disabled && "disabled")}>
					{/* <div className="favorite">
						<i className="far fa-heart" />
					</div> */}
					<div
						className={"product-thumb " + (item.menuId ? "cursor-pointer" : "")}
						onClick={() => item.menuId && onClickItem(item)}
					>
						<img
							// style={{ width: "750px" }}
							src={
								item.image
									? item.image
									: process.env.PUBLIC_URL + "/assets/img/no-image.png"
							}
							alt={item.name}
						/>
					</div>
					<div className="product-body">
						<div className="product-desc">
							<h4
								className={item.menuId ? "cursor-pointer" : ""}
								onClick={() => item.menuId && onClickItem(item)}
							>
								{" "}
								{item.name}
							</h4>
							{/* <div className="ct-rating-wrapper">
								<div className="ct-rating">{Rating(item.rating)}</div>
							</div> */}
							<p className="product-description-text">{item.description}</p>
							{/* {item.menuId ? (
							<Link
								to="#"
								className="btn-custom light btn-sm shadow-none"
								onClick={(e) => modalShow(item.menuId)}
							>
								{" "}
								Customize <i className="fas fa-plus" />{" "}
							</Link>
						) : null} */}
						</div>
						<div className="product-controls">
							<p className="product-price">
								{basket.mode == "takeAway" && item.priceTakeAway > 0
									? parseFloat(item.priceTakeAway).toFixed(2)
									: basket.mode == "delivery" && item.priceDelivery > 0
									? parseFloat(item.priceDelivery).toFixed(2)
									: parseFloat(item.price).toFixed(2)}{" "}
								€
							</p>
							{item.disabled ? null : (
								<button
									onClick={(e) => onClickItem(item, e)}
									className="btn-order order-item btn-custom btn-sm shadow-none"
								>
									Commander
									<span className="icon-shopping">
										<i className="flaticon-shopping-bag" />
									</span>
								</button>
							)}
						</div>
					</div>
				</div>
			</div>
		));
	return (
		<Fragment>
			{/* Menu Categories Start */}
			<div className="ct-menu-categories menu-filter" style={{}}>
				<div className="container relative">
					{showArrows() && (
						<div className="slider-arrow slider-arrow-left">
							<i
								className="fas fa-chevron-left"
								onClick={() => sliderRef.current.slickPrev()}
							/>
						</div>
					)}
					<Slider
						ref={(ref) => (sliderRef.current = ref)}
						className="menu-category-slider"
						{...settings}
					>
						{/* <Link
							to="#"
							data-filter="*"
							className={
								state.activeItem === -1
									? "ct-menu-category-item active"
									: "ct-menu-category-item"
							}
							onClick={() => handleClick(-1)}
						>
							<div className="menu-category-thumb">
								<img
									src={process.env.PUBLIC_URL + "/assets/img/categories/6.jpg"}
									alt="All"
								/>
							</div>
							<div className="menu-category-desc">
								<h6>Tout</h6>
							</div>
						</Link> */}
						{props.categories.map((item, i) => (
							<Link
								key={i}
								to={`?category=${item.categoryName}`}
								className={
									state.activeItem === item.categoryName
										? "ct-menu-category-item active"
										: "ct-menu-category-item"
								}
								onClick={() => handleClick(item.categoryName)}
							>
								<div
									className="menu-category-thumb"
									style={{
										width: item.displayName == 1 ? "100px" : "130px",
										height: item.displayName == 1 ? "100px" : "130px",
									}}
								>
									<img
										// style={{ width: "250px" }}
										src={item.categoryImage}
										alt={item.categoryName}
									/>
								</div>
								{item.displayName == 1 && (
									<div className="menu-category-desc">
										<h6>{item.categoryName}</h6>
									</div>
								)}
							</Link>
						))}
					</Slider>

					{showArrows() && (
						<div className="slider-arrow slider-arrow-right">
							<i
								className="fas fa-chevron-right"
								onClick={() => sliderRef.current.slickNext()}
							/>
						</div>
					)}
				</div>
			</div>
			{/* Menu Categories End */}
			{/* Menu Wrapper Start */}
			<div className="section section-padding">
				<div className="container">
					<Masonry
						className="menu-container row menu-v2"
						imagesLoadedOptions={imagesLoadedOptions}
					>
						{/* Product Start */}
						{renderAll}
						{/* Product End */}
					</Masonry>
				</div>
			</div>
			{state.modalshow == true && (
				<Modal
					show={state.modalshow}
					id="customizeModal"
					onHide={modalClose}
					aria-labelledby="contained-modal-title-vcenter"
					size="lg"
					centered
				>
					<Quickview
						productId={state.lastActiveBox}
						onHide={modalClose}
						optionLists={props.optionLists}
					/>
				</Modal>
			)}
			{state.modaloptions == true && (
				<Modal
					show={state.modaloptions}
					id="customizeModal"
					onHide={modalClose}
					aria-labelledby="contained-modal-title-vcenter"
					size="lg"
					centered
				>
					<QuickviewOptions
						productId={state.lastActiveBox}
						product={state.filteredProducts.find(
							(i) => i.productId == state.lastActiveBox
						)}
						addItemToCart={addProductToCart}
						onHide={modalClose}
					/>
				</Modal>
			)}
			{state.showSelectMode == true && !basket.mode && (
				<Modal
					show={state.showSelectMode}
					id="selectModeModal"
					aria-labelledby="contained-modal-title-vcenter"
					size="lg"
					centered
				>
					<SelectMode
						onHide={() => {
							setState({ ...state, showSelectMode: false });
						}}
					/>
				</Modal>
			)}
			{/* Menu Wrapper End */}
		</Fragment>
	);
};

export default Content;
